import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-input-chip',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './input-chip.component.html',
  styleUrl: './input-chip.component.css',
})
export class InputChipComponent {
  @Input() label = 'Value';
  @Input() placeholder = 'Enter value';
  @Input() showAsterisk = false;
  @Input() required = false;
  @Input() disabled = false;
  @Input() values: string[] = [];
  @Output() valuesChange = new EventEmitter<string[]>();

  @ViewChild('chipContainer') chipContainer?: ElementRef<HTMLDivElement>;

  valueInput = '';

  onChipKeydown(event: KeyboardEvent) {
    const isTriggerKey = event.key === 'Enter' || event.key === 'Tab';
    const trimmed = this.valueInput.trim();
    if (isTriggerKey && trimmed && !this.disabled) {
      event.preventDefault();
      this.addChip(trimmed);
    }
  }

  addChip(value: string) {
    if (!value || this.values.includes(value)) {
      this.valueInput = '';
      return;
    }
    this.values = [...this.values, value];
    this.emitChanges();
    this.valueInput = '';
    this.scrollChipsToBottom();
  }

  removeChip(index: number) {
    if (this.disabled) return;
    this.values = this.values.filter((_, i) => i !== index);
    this.emitChanges();
  }

  private emitChanges() {
    this.valuesChange.emit(this.values);
  }

  private scrollChipsToBottom() {
    setTimeout(() => {
      const el = this.chipContainer?.nativeElement;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    });
  }
}
